import { useCallback, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { resourcesBaseUri } from "../../config";
import { Localization } from "../../model/store/providers/Localization";
import './Footer.scss';

const Footer = () => {
	const navigate = useNavigate();
	const navigateToHome = useCallback((event) => {
		event.preventDefault();
		navigate('/');
	}, [navigate]);
	const navigateToFaq = useCallback((event) => {
		event.preventDefault();
		navigate('/faq');
	}, [navigate]);
	const { translations } = useContext(Localization.State);
	const {
		footer: {
			privacy,
			terms,
			copyright
		}
	} = translations;

	return (
		<div className="footer">
			<img
				className="footer__logo"
				src={`${resourcesBaseUri}/rblogo-trans.png`}
				alt="logo"
				onClick={navigateToHome}
			/>
			<div className="footer__lower">
				<div className="footer__links">
					<span className="footer__privacy"><a className="footer__link" href="https://www.ritchiebros.com/privacy-statement">{privacy}</a></span>
					<span className="footer__terms"><a className="footer__link" href="https://www.rbauction.com/myaccount/terms-and-conditions">{terms}</a></span>
					<span className="footer__faq"><span className="footer__link" onClick={navigateToFaq}>FAQ</span></span>
				</div>
				<span className="footer__legal-text">© { new Date().getFullYear() } Ritchie Bros. Auctioneers, Inc. {copyright}</span>
			</div>
		</div>
	);
}

export default Footer;